/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Link } from '../routes';
import FlexBox from './FlexBox';

import urlConfig from '../config/urls';
import { getLabel } from '../utils/i18n';

const {
  user: {
    orderHistory: ORDER_HISTORY_URL,
    marginOrderHistory: MARGIN_ORDER_HISTORY_URL,
  },
} = urlConfig;

const ToggleInput = styled.input`
  margin-right: .5em;
  vertical-align: middle;
`;

const Panel = styled(FlexBox)`
  position: ${({ position }) => position || 'absolute'};
  right: ${({ pro }) => pro ? '5px' : '0'};
  /* bad */
  top: ${({ pro }) => pro ? '-26px' : '-23px'};
  color: ${({ theme }) => theme.fontColor};
  & >a, a:visited {
      text-decoration:underline;
      margin-left: 24px;
    }
`;

const ToggleLabel = styled.label`
    vertical-align: middle;
`;

export type Props = {
  id: string,
  locale: string,
  i18n: Object,
  pro: boolean,
  readMore: boolean,
  textKey?: string,
  position?: string,
  onChange: Function,
  marginStatus: boolean,
};

const SelfOtherPairsTogglr = (props: Props) => (
  <Panel pro={props.pro} position={props.position}>
    <ToggleLabel htmlFor={`${props.id}`}>
      <ToggleInput id={props.id} type="checkbox" {...props} />
      {props.textKey ? (props.i18n[props.textKey] || props.textKey) : getLabel('exchange-SelfOtherPairsToggler-HideOtherPairs', props.i18n)}
    </ToggleLabel>
    { props.pro || !props.readMore ? null : (
      <Link href={props?.marginStatus ? MARGIN_ORDER_HISTORY_URL.replace('%locale', props.locale) : ORDER_HISTORY_URL.replace('%locale', props.locale)}>
        <a>
          {/* {(props.i18n || {}).viewAll || 'More'} */}
          {getLabel('exchange-SelfOtherPairsToggler-More', props.i18n).replace('%locale', props.locale)}
        </a>
      </Link>
    )}
  </Panel>
);

SelfOtherPairsTogglr.defaultProps = {
  locale: 'en',
  textKey: '',
  onChange: () => {},
};

export default SelfOtherPairsTogglr;
